import { HttpErrorResponse } from '@angular/common/http';
import { passwordReusedErrorCode } from '../constants/error-messages.constants';

/** Drops the `": [context]"` support detail the backend appends to a message*/
export function stripErrorContext(message: string): string {
    return message.split(': [')[0].trim();
}

/**
 * The backend wording for a password rejected as already used, or null when the save failed for another reason.
 */
export function getPasswordReusedMessage(error: HttpErrorResponse): string | null {
    const { messages, codes } = error.error ?? {};
    if (!Array.isArray(codes) || !Array.isArray(messages)) {
        return null;
    }

    const index = codes.indexOf(passwordReusedErrorCode);
    const message = index < 0 ? null : messages[index];

    return message ? stripErrorContext(String(message)) : null;
}
